import FingerPrint from "./FingerPrint.js"
import APIUser from "./APIUser.js"
import SpinnerEvent from "../Spinner/SpinnerEvent.js"

export default class APIClient {

    async getAuthHeader() {

        if (!this.apiUser.isSoftLoggedIn()) {
            return null
        }

        if (this.apiUser.isLoggedIn()) {
            return this.apiUser.getAuthHeader()
        }

        return this.fetchAuth({

            JWT: this.apiUser.getJWT()

        }).then(status => {

            if (status) {
                return this.apiUser.getAuthHeader()
            }

        }).catch(error => {

            this.apiUser.logOut()
        })
    }

    async fetchAuth(p) {
        
        const params = this.getFetchParams({
            body: p,
            method: "post",
            endPoint: this.auth.endPoint,
            server: this.auth.server || this.server
        })
        
        SpinnerEvent.show(this.spinnerId)

        return fetch(
            params.url,
            params.options
        ).then(result => {

            if (!result.ok) {

                SpinnerEvent.hide(this.spinnerId)
                const error = new Error(result.status)
                error.code = result.status
                throw error
            }

            return result.json()

        }).then(jwt => {
            
            if (jwt?.Results?.JWT?.Payload?.JWT) {

                SpinnerEvent.hide(this.spinnerId)
                return this.apiUser.logIn(
                    jwt.Results.JWT.Payload.JWT
                )
            }

        }).catch(jwtError => {
            
            SpinnerEvent.hide(this.spinnerId)
            const error = new Error(jwtError)
            error.code = jwtError.code
            error.type = "auth"
            throw error
        })
    }

    getFetchParams(p) {

        const src = Object.assign(
            {},
            p
        )

        src.server = typeof p.server === "undefined" ?
            this.server :
            p.server

        src.filter = p.filter || {}
        src.filter = typeof p.filter === "undefined" ?
            {} :
            Object.assign({}, p.filter)

        src.filter.preview = true
        src.method = p.method || "get"
        src.headers = p.headers || {}
        src.options = p.options || {}
        src.body = p.body || {}
        src.isJSON = typeof p.isJSON === "undefined" ?
            true :
            p.isJSON

        const params = {}

        params.options = Object.assign(
            {},
            this.options,
            src.options
        )

        params.options.headers = Object.assign(
            {},
            this.headers,
            src.headers,
        )

        params.options.headers.xfp = this.fp
        params.options.method = src.method

        if (src.method !== "get") {

            params.options.body = src.body

            if (src.isJSON) {

                params.options.headers[
                    "content-type"
                ] = "application/json"

                params.options.body = JSON.stringify(
                    src.body
                )
            }
        }

        params.url = (
            src.server
            + "/" + src.endPoint
            + "?" + new URLSearchParams(
                src.filter
            )
        )

        return params
    }

    async fetch(p) {

        const params = this.getFetchParams(p)
        
        SpinnerEvent.show(this.spinnerId)

        return this.getAuthHeader().then(jwt => {

            if (jwt) {
                params.options.headers.authorizationalt = jwt
            }

            return fetch(
                params.url,
                params.options
            ).then(result => {

                if (!result.ok) {
                    const error = new Error(result.status)
                    error.code = result.status
                    throw error
                }

                SpinnerEvent.hide(this.spinnerId)
                return result.json()

            }).catch(resultError => {

                SpinnerEvent.hide(this.spinnerId)
                const error = new Error(resultError)
                error.code = resultError.code
                error.type = "fetch"
                throw error
            })
        })

    }

    constructor(p) {

        Object.entries(
            p
        ).forEach(([id, value]) => {
            this[id] = value
        })

        this.headers = this.headers || {}
        this.fp = FingerPrint.get()

        this.apiUser = new APIUser({
            jwtKey: p.auth.jwtKey
        })

        this.spinnerId = p.spinnerId || "main"
    }
}